import { StoryblokComponent } from '@storyblok/react';
import React from 'react';

import { ServiceOSLogin } from 'apps/urban/components/ServiceOS/ServiceOSLogin/ServiceOSLogin';
import Link from 'next/link';

import { useMobileView } from '../../../hooks/useMobileView';
import { TNavigation, TNavigationItem } from '../HeaderV2.types';
import { HeaderV2Basket } from '../HeaderV2Basket/HeaderV2Basket';
import { HeaderV2Dropdown } from '../HeaderV2Dropdown/HeaderV2Dropdown';
import { HeaderV2Initials } from '../HeaderV2Initials/HeaderV2Initials';
import {
  HeaderNavWrapper,
  HeaderNavItem,
  HeaderNavItems,
  HeaderNavItemLink,
  HeaderNavItemLinkWrapper,
  HeaderNavItemLinkContainer,
  HeaderV2NavApplyButtonWrapper,
} from './HeaderV2Nav.style';

const navItemHasColumns = (navigationItem: TNavigationItem) => !!navigationItem.columns?.length;

export const HeaderV2Nav = ({
  navigation,
  setOpen,
  setDropdownOpen,
  showBasket,
  showInitials,
  basketData,
  basketButtonText,
  enableDropdown,
  dropdownFooter,
  hasBackground,
  useServiceOsAuth,
  removeBookNowButton,
  applyNowButton,
}: TNavigation) => {
  const { isMobile } = useMobileView();

  const handleNavLinkHover = (navigationItem: TNavigationItem, isDropdownOpen: boolean) => {
    if (setDropdownOpen && enableDropdown && navItemHasColumns(navigationItem)) {
      setDropdownOpen(isDropdownOpen);
    }
  };

  return (
    <HeaderNavWrapper>
      {useServiceOsAuth && !isMobile && <ServiceOSLogin />}
      {navigation.map((navigationItem) => {
        return (
          <HeaderNavItemLinkContainer key={navigationItem._uid}>
            <HeaderNavItemLinkWrapper
              className={
                enableDropdown && navItemHasColumns(navigationItem)
                  ? 'header-v2-nav-item-link-wrapper'
                  : undefined
              }
              onMouseEnter={() => handleNavLinkHover(navigationItem, true)}
              onMouseLeave={() => handleNavLinkHover(navigationItem, false)}
            >
              <Link
                prefetch={false}
                href={
                  navigationItem.item.cached_url.startsWith('http')
                    ? navigationItem.item.cached_url
                    : `/${navigationItem.item.cached_url}`
                }
                passHref
              >
                <HeaderNavItemLink onClick={() => setOpen(false)}>
                  <HeaderNavItem hasBackground={hasBackground} className="header-v2-nav-item">
                    <StoryblokComponent blok={navigationItem.title[0]} />
                  </HeaderNavItem>
                </HeaderNavItemLink>
              </Link>
              {enableDropdown && !!navigationItem.columns?.length && (
                <HeaderV2Dropdown navigationItem={navigationItem} footer={dropdownFooter} />
              )}
            </HeaderNavItemLinkWrapper>
          </HeaderNavItemLinkContainer>
        );
      })}
      {(showBasket || showInitials) && (
        <HeaderNavItems>
          {showBasket && (
            <HeaderV2Basket
              basketData={basketData}
              basketButtonText={basketButtonText}
              useServiceOsAuth={useServiceOsAuth}
              removeBookNowButton={removeBookNowButton}
            />
          )}
          {showInitials && <HeaderV2Initials />}
          {applyNowButton?.length > 0 && (
            <HeaderV2NavApplyButtonWrapper>
              <StoryblokComponent blok={applyNowButton[0]} className="HeaderV2NavApplyButton" />
            </HeaderV2NavApplyButtonWrapper>
          )}
        </HeaderNavItems>
      )}
    </HeaderNavWrapper>
  );
};
